import { useAuth } from "@/features/auth";
import { Button, Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/shared/components";
import { useEffect } from "react";
import { useNavigate } from "react-router";

/**
 * UnauthorizedPage displays a message for SSO users who are authenticated
 * but don't have any of the required AD groups/roles to access the application.
 */
export default function UnauthorizedPage() {
    const navigate = useNavigate();
    const { previewRole } = useAuth();
    // listen to change in preview role and redirect back to homepage
    useEffect(() => {
        if (previewRole !== null) {
            void navigate("/");
        }
    }, [previewRole, navigate]);

    const handleContactSupport = () => {
        window.location.href = "mailto:sein@ns.nl?subject=Toegangsverzoek SEIN applicatie";
    };

    return (
        <div className="bg-background m-auto flex min-h-screen flex-col items-center justify-center p-4">
            <Card className="w-full max-w-md text-center">
                <CardHeader>
                    <div className="text-destructive text-6xl font-bold">403</div>
                    <CardTitle className="text-xxl mt-4">Geen toegang</CardTitle>
                    <CardDescription className="text-left">
                        Je bent succesvol ingelogd, maar je hebt niet de vereiste rol om toegang te krijgen tot deze applicatie. Neem
                        contact op met het SEIN-team op{" "}
                        <a href="mailto:sein@ns.nl" className="text-primary underline">
                            sein@ns.nl
                        </a>{" "}
                        om toegang aan te vragen.
                    </CardDescription>
                </CardHeader>
                <CardFooter className="flex justify-center">
                    <Button onClick={handleContactSupport} icon="mail">
                        Contact opnemen
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
}
